import { Component, OnInit } from '@angular/core';
import { ConsultasService } from '@app/services/consultas.service';
import { IdDescricao } from '@app/models/util/id-descricao';

@Component({
  selector: 'app-rel-financeiro-fluxodecaixadiario',
  templateUrl: './fluxo-de-caixa-diario.component.html'
})
export class RelatorioFluxoDeCaixaDiarioComponent implements OnInit {
  lstUnidades: IdDescricao[] = [];
  lstConta: IdDescricao[] = [];

  constructor(
    private consultasService: ConsultasService
  ) { }

  ngOnInit(): void {
    this.consultasService.consultar('UNIDADE_S_RATEIO').subscribe(data => this.lstUnidades = data);
    this.consultasService.consultar('CONTA').subscribe(data => this.lstConta = data);
  }

}

